<template>
    <div v-if="item" class="carrier-row">
        <div
            v-if="!enabledItem && index === 0 && show"
            class="row-space-between pl16 pr16 pt10 pb10 hr-bottom"
        >
            <div>{{ $t('components.inTheCourseOfShipment') }}</div>
            <div>{{ $t('components.sendInFewSec') }} {{ time }}</div>
        </div>
        <div>
            <div v-if="item.medal !== 0" class="medal">
                <img :src="require(`@assets/images/${item.medal}.svg`)" />
            </div>

            <div v-if="item.payment_type !== null" class="vip-label">
                <div>VIP</div>
            </div>

            <div class="row-space-between" style="align-items: center;">
                <div
                    :class="{
                        'company-name': true,
                        'light-gray': !enabledItem,
                        'margin-left': item.payment_type !== null
                    }"
                >
                    <img
                        v-if="item.avatar"
                        :class="{
                            'carrier-avatar': true,
                            disabled: !enabledItem
                        }"
                        :src="
                            `https://flotea.pl/files/images/avatars/${item.avatar}`
                        "
                    />
                    <div
                        v-else
                        class="carrier-avatar first_logo pt20"
                        :class="{
                            disabled: !enabledItem
                        }"
                    >
                        {{ item.company_name.substring(0, 1) }}
                    </div>

                    <div class="carrier-name">
                        {{ item.company_name }}
                        <span v-if="isSpectrum" class="c9c9c9c"
                            >{{ from }} > {{ to }}</span
                        >
                    </div>
                </div>
                <attributes-icons
                    class="ml-auto"
                    v-if="isSpectrum && windowWidth > 550"
                    :attributes="item.additional_options.options"
                />
                <div class="right-row">
                    <attributes-icons
                        v-if="isSpectrum && windowWidth <= 550"
                        :attributes="item.additional_options.options"
                    />
                    <div>
                        <span
                            v-if="item.deposit_price || deposit"
                            class="price pt15 mobile"
                            >{{ item.deposit_price }} zł</span
                        >
                        <div
                            v-if="enabledStatus"
                            class="status"
                            :class="{
                                cadc247: enabledItem,
                                'light-gray': !enabledItem
                            }"
                        >
                            <div v-if="item.deposit_paied" class="created-at">
                                {{ item.deposit_paied_at | formatDateTime }}
                            </div>
                            <div style="text-transform: lowercase;">
                                {{
                                    enabledItem
                                        ? renderStatusMessages(
                                              item.order_status
                                          )
                                        : this.$t('orders.forDispatch')
                                }}
                            </div>
                            <Statuses
                                v-if="enabledItem"
                                :orderStatus="item.order_status"
                            />
                            <Statuses v-else :orderStatus="[0, 0, 0]" />
                        </div>
                    </div>
                    <div v-if="enabledItem" class="pr16 flex">
                        <div
                            v-if="deposit || item.deposit_price"
                            style="display: inline-flex;"
                        >
                            <span class="price pt15 desktop"
                                >{{ item.deposit_price }} zł</span
                            >
                            <md-button
                                v-if="!paied"
                                :class="{
                                    'card-call-btn bgc-default min-width': true,
                                    'disabled-background': item.deposit_paied
                                }"
                                @click="depositButton"
                            >
                                <img
                                    :src="require('@assets/images/ticket.svg')"
                                    alt="kredyt"
                                    title="kredyt"
                                />
                                <div class="call-text uppercase">
                                    {{
                                        item.deposit_paied
                                            ? $t('components.paid')
                                            : $t('route.deposit')
                                    }}
                                </div>
                            </md-button>
                        </div>
                        <div v-if="enabledStatus">
                            <md-button
                                :class="{
                                    'card-call-btn min-width': true,
                                    'white-outlined-button':
                                        !enabledCall && !item.order_status[1],
                                    'gray-button': call
                                }"
                                @click="callButton(item)"
                            >
                                <img
                                    v-if="enabledCall || item.order_status[1]"
                                    :src="
                                        require('@assets/images/icon-call.svg')
                                    "
                                    alt="zadzwoń"
                                    title="zadzwoń"
                                />
                                <div
                                    v-if="enabledCall || item.order_status[1]"
                                    class="uppercase"
                                    :class="{
                                        'call-text':
                                            enabledCall || item.order_status[1]
                                    }"
                                >
                                    {{
                                        call
                                            ? $t('components.calling')
                                            : $t('global.call')
                                    }}
                                </div>
                                <div
                                    v-else
                                    class="uppercase"
                                    :class="{
                                        'call-text':
                                            enabledCall || item.order_status[1]
                                    }"
                                >
                                    {{ $t('route.sendDeposit') }}
                                </div>
                            </md-button>
                            <md-tooltip
                                v-if="!enabledCall && !item.order_status[1]"
                                md-direction="left"
                                >{{
                                    $t('components.sendContactRequest')
                                }}</md-tooltip
                            >
                        </div>

                        <md-button
                        @click="setMarkedPhoneInput(true)"
                            v-else
                            :class="{
                                'card-call-btn min-width': true,
                                'disabled-background': !enabledCall,
                                'gray-button': call
                            }"
                        >
                            <img
                                :src="require('@assets/images/icon-call.svg')"
                                alt="zadzwoń"
                                title="zadzwoń"
                            />
                            <div class="call-text uppercase">
                                {{
                                    call
                                        ? $t('components.calling')
                                        : $t('global.call')
                                }}
                            </div>
                        </md-button>
                        <md-tooltip
                            v-if="!enabledStatus && !call && !isLogged"
                            md-direction="left"
                        >
                            <span ng-bind-html="msg | unsafeSpecial" v-html="$t('components.authorizePhone')"/>
                        </md-tooltip>

                        <md-button
                            v-if="call && enabledItem"
                            :class="{
                                'card-call-btn bgc-default f85b5a min-width': true,
                                'disabled-background': !enabledCall
                            }"
                            @click="confirmButton(item)"
                        >
                            <div class="uppercase">{{ $t('global.IConfirm') }}</div>
                        </md-button>

                        <div v-if="call && enabledItem" class="bar">
                            <div class="progress-bar">
                                <span
                                    >{{ $t('components.confirmDeparture') }}
                                    {{ timeToWait }}</span
                                >
                                <md-progress-bar
                                    style="width:260px"
                                    md-mode="determinate"
                                    :md-value="progressWidth"
                                ></md-progress-bar>
                            </div>
                        </div>

                        <after-call-with-carrier
                            :show="confirmModal"
                            @close="
                                () => {
                                    confirmModal = false;
                                }
                            "
                            @confirm="confirmButton(item)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Statuses from './Statuses';
import AfterCallWithCarrier from '../modals/afterCallWithCarrier';
import AttributesIcons from '../components/AttributesIcons.vue';
import moment from 'moment';
export default {
    props: {
        item: {
            type: Object,
            default: {}
        },
        enabledCall: {
            type: Boolean,
            default: true
        },
        enabledItem: {
            type: Boolean,
            default: true
        },
        index: {
            type: Number,
            default: 0
        },

        show: {
            type: Boolean,
            default: true
        },

        call: {
            type: Boolean,
            default: false
        },

        deposit: {
            type: Boolean,
            default: false
        },

        callTimeToWait: {
            type: Number,
            default: 0
        },

        isMobile: {
            type: Boolean,
            default: false
        },

        enabledStatus: {
            type: Boolean,
            default: true
        },

        isSpectrum: {
            type: Boolean,
            default: false
        },

        from: {
            type: String,
            default: ''
        },

        to: {
            type: String,
            default: ''
        },

        time: {
            type: String,
            default: '00:00'
        }
    },

    components: {
        Statuses,
        AfterCallWithCarrier,
        AttributesIcons
    },

    filters: {
        formatDateTime(value) {
            if (value) {
                return moment(String(value))
                    .add(2, 'hours')
                    .format('DD.MM.YYYY hh:mm');
            }
        }
    },

    data() {
        return {
            timeToWait: '',
            progressWidth: 100,
            confirmModal: false,
            confirmed: false,
            paied: false,
            windowWidth: window.innerWidth
        };
    },

    watch: {
        combined() {
            if (this.call && this.callTimeToWait) {
                this.showPhoneNumber(this.callTimeToWait);

                setTimeout(() => {
                    this.confirmed ? '' : (this.confirmModal = true);
                }, 7000);

                return;
            }

            if (this.callTimeToWait) {
                this.showPhoneNumber(this.callTimeToWait);
            }
        }
    },

    computed: {
        ...mapGetters({
            currentPassenger: 'auth/currentPassenger',
            isLogged: 'auth/loggedInAsPassenger'
        }),

        combined() {
            return this.call === true || this.callTimeToWait !== 0;
        }
    },

    methods: {
        ...mapActions({
            advancePaymentTransfer: 'passengerContent/advancePaymentTransfer',
            getPassenger: 'auth/validatePassengerToken',
            sendSMS: 'content/carrierSms'
        }),
        ...mapMutations({
            setMarkedPhoneInput:'global/SET_MARKED_PHONE_INPUT'
        }),

        renderStatusMessages(orderStatu) {
            const data = orderStatu.join('');

            if (data === '000') {
                return this.$t('orders.orders');
            }

            if (data === '100') {
                return this.$t('route.sent');
            }

            if (data === '110') {
                return this.$t('orders.conversation');
            }

            if (data === '111') {
                return this.$t('orders.taken');
            }
        },

        async showPhoneNumber(t) {
            const date = moment(t);
            let subtract = date;

            const intvl = setInterval(() => {
                this.timeToWait = subtract.format('mm:ss');
                subtract = subtract.subtract(1, 'seconds');

                this.progressWidth = (t / 300000) * 100;
                t -= 1000;

                if (this.progressWidth <= 0) {
                    clearInterval(intvl);
                    this.progressWidth = 100;
                }
            }, 1000);
        },

        callButton(item) {
            const params = {
                carrierUUID: item.carrier_uuid,
                msg: [{ cmd: 'passenger_call' }],
                deposit: false,
                voip: item.phonenumber
            };

            if (item.order_status[1]) {
                this.isMobile
                    ? (location.href = 'tel:' + item.phonenumber)
                    : window.open('tel:' + item.phonenumber, 'downloadIframe');

                return;
            }

            if (!item.order_status[1] && this.enabledCall) {
                this.$emit('toRabbit', params);

                return;
            } else if (!this.enabledCall && !this.call) {
                const { inquiryUUID } = this.$route.params;
                this.sendSMS({ carrierUUID: item.carrier_uuid, inquiryUUID });
                this.$toast.success(
                    this.$t('components.contactRequestHasBeenSentToCarrier')
                );
                return;
            }
        },

        async depositButton() {
            const { accountBalance } = this.currentPassenger;
            const { item } = this;
            const { inquiryUUID } = this.$route.params;

            if (item.deposit_paied) {
                return;
            }

            if (accountBalance < item.deposit_price) {
                this.$emit('showAdvanceModal');

                return;
            }

            const params = {
                request_uuid: inquiryUUID,
                carrier_uuid: item.carrier_uuid,
                msg: null
            };

            try {
                const response = await this.advancePaymentTransfer(params);

                if (response) {
                    await this.getPassenger();
                    this.paied = true;
                    params.msg = [{ cmd: 'depo_paied' }];
                    this.$emit('toRabbit', params);
                    this.$toast.success(this.$t('deposits.depositPaied'));
                } else {
                    this.paied = false;
                }
            } catch (error) {
                this.$toast.error(this.$t('global.somethingWrong'));
            }
        },

        confirmButton(item) {
            this.confirmModal = false;
            this.confirmed = true;
            const params = {
                carrierUUID: item.carrier_uuid,
                msg: [{ cmd: 'take' }]
            };

            this.$emit('toRabbit', params);
        },

        getWindowWidth() {
            this.windowWidth = window.innerWidth;
        }
    },

    mounted() {},

    created() {
        window.addEventListener('resize', this.getWindowWidth);
    },
    destroyed() {
        window.removeEventListener('resize', this.getWindowWidth);
    }
};
</script>
<style lang="scss" scoped>
.hr-bottom {
    border-bottom: 1px solid #21212114;
}

.flex {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.gray-button {
    background: #979797 !important;
}

.price {
    display: block !important;
}

.min-width {
    min-width: 126px !important;
}

.f85b5a {
    background-color: #f85b5a !important;
    height: 36px;
}

.mobile {
    display: none !important;
}

.created-at {
    display: none;
}

@media only screen and (max-width: 550px) {
    .row-space-between {
        display: block;
    }

    .right-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .mobile {
        display: block !important;
    }

    .desktop {
        display: none !important;
    }
    .status {
        display: flex;
        flex-direction: column-reverse;
        align-items: flex-start;
    }

    .carrier-avatar {
        margin: 7px 14px 7px 0px !important;
    }

    .margin-left {
        margin-left: 15px !important;
    }

    .created-at {
        display: block;
        font-weight: 500;
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 1.5px;
        text-transform: uppercase;
        color: rgba(0, 0, 0, 0.87);
    }

    .bar {
        height: 45px;
    }
}

.carrier-name {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 260px;

    span {
        font-size: 13px;
    }
}

.white-outlined-button {
    background-color: #ffffff !important;
    border: 1px solid #4558de;
    color: #4558de !important;
    padding: 8px 0 8px 0 !important;
}
</style>
